<div *ngIf='formReady' class='update-pipelines'>
  <form [formGroup]='formGroup'>
    <div class='row'>
      <div class='col-12'>
        <mat-form-field>
          <mat-label>Product :</mat-label>
          <mat-select
            (selectionChange)='onChangeSelect($event, "user_product_id")'
            formControlName='user_product_id'
            required>
            <mat-option *ngFor='let item of products' [value]='item.id'>
              {{ item.product_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class='col-12'>
        <mat-form-field>
          <mat-label>Status :</mat-label>
          <mat-select
            (selectionChange)='onChangeSelect($event, "status")'
            formControlName='status'>
            <mat-option [value]='0'>
              {{ 'Active' }}
            </mat-option>

            <mat-option [value]='1'>
              {{ 'Won' }}
            </mat-option>

            <mat-option [value]='2'>
              {{ 'Lost' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="action == 'update' && status == '1'" class='col-12'>
        <mat-form-field>
          <mat-label>Actual value :</mat-label>

          <input formControlName='actual_value' matInput name='actual_value' />
        </mat-form-field>
      </div>

      <div *ngIf="action == 'update' && status == '1'" class='col-12'>
        <mat-form-field>
          <mat-label>Estimated value :</mat-label>

          <input
            formControlName='estimated_value'
            matInput
            name='estimated_value' />
        </mat-form-field>
      </div>
      <div *ngIf="action == 'update' && status == '2'" class='col-12'>
        <mat-form-field>
          <mat-label>Lost reason :</mat-label>

          <input
            formControlName='lost_reason'
            matInput
            name='lost_reason' />
        </mat-form-field>
      </div>

      <div *ngIf="action == 'update'" class='col-12'>
        <div>Description:</div>
        <app-editor formControlName='description'></app-editor>
      </div>

      <div *ngIf="action == 'update'" class='col-12'>
        <div>Estimated closing date:</div>
        <div>
          <mat-form-field appearance='fill'>
            <input
              [matDatepicker]='picker'
              formControlName='estimated_date'
              matInput />
            <mat-datepicker-toggle
              [for]='picker'
              matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker [startAt]='startDate'></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="action == 'update'" class='col-12'>
        <div>Status date:</div>
        <div>
          <mat-form-field appearance='fill'>
            <input
              [matDatepicker]='picker2'
              formControlName='status_date'
              matInput />
            <mat-datepicker-toggle
              [for]='picker2'
              matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker2 [startAt]='startDate'></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="action == 'update' && status == '1'" class='col-12'>
        <div>Renewal date:</div>
        <div>
          <mat-form-field appearance='fill'>
            <input
              [matDatepicker]='picker3'
              formControlName='renewal_date'
              matInput />
            <mat-datepicker-toggle
              [for]='picker3'
              matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker3 [startAt]='startDate'></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="action == 'update'" class='col-12'>
        <mat-form-field>
          <mat-label>Pipeline :</mat-label>
          <mat-select
            (selectionChange)='onChangeSelect($event)'
            formControlName='pipeline'>
            <ng-container *ngIf='pipelines'>
              <mat-option *ngFor='let item of pipelines' [value]='item.id'>
                {{ item.pipeline }}
              </mat-option>
            </ng-container>
            <ng-container *ngIf='defaultPipelines'>
              <mat-option *ngFor='let item of defaultPipelines' [value]='item'>
                {{ item }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <div class='row controls'>
        <div class='col-6'>
          <app-button
            (click)='submit()'
            *ngIf="action == 'new'"
            [color]="'orange'"
            [disabled]='!formGroup.valid'
            [size]="'small'"
            [text]="'Add'"></app-button>
          <app-button
            (click)='submit()'
            *ngIf="action == 'update'"
            [color]="'orange'"
            [size]="'small'"
            [text]="'Update'"></app-button>
        </div>
        <div class='col-6'>
          <app-button
            (click)='back()'
            [color]="'white'"
            [size]="'small'"
            [text]="'Back'"
            class='pull-right'></app-button>
        </div>
      </div>
    </div>
  </form>
</div>
